const stats = [
  { icon: 'ri-shield-user-fill', value: '500+', label: 'Families Protected', color: 'from-[#D97642] to-[#C26638]' },
  { icon: 'ri-calendar-check-fill', value: '12', label: 'Years of Experience', color: 'from-[#1A3A52] to-[#2d5a8c]' },
  { icon: 'ri-building-2-fill', value: '20+', label: 'A-Rated Carriers', color: 'from-[#D97642] to-[#C26638]' },
  { icon: 'ri-map-pin-2-fill', value: '24+', label: 'Indiana Communities', color: 'from-[#1A3A52] to-[#2d5a8c]' },
  { icon: 'ri-star-fill', value: '5.0★', label: 'Average Rating', color: 'from-[#D97642] to-[#C26638]' },
];

function StatItem({ stat }: { stat: typeof stats[0] }) {
  return (
    <div className="flex flex-col items-center text-center group">
      <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${stat.color} shadow-lg mb-4 group-hover:scale-110 transition-transform duration-300`}>
        <i className={`${stat.icon} text-[26px] text-white`}></i>
      </div>
      <div className="text-[38px] md:text-[48px] font-extrabold text-white leading-none tracking-tight">
        {stat.value}
      </div>
      <div className="mt-2 text-[13px] md:text-[14px] text-white/70 font-medium uppercase tracking-widest">
        {stat.label}
      </div>
    </div>
  );
}

export default function StatsBanner() {
  return (
    <section
      className="relative py-16 md:py-20 overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #0f2236 0%, #1A3A52 40%, #1e4a6e 70%, #0f2236 100%)',
      }}
    >
      {/* Decorative glows */}
      <div className="absolute top-0 left-1/4 w-72 h-72 bg-[#D97642]/20 rounded-full blur-[80px] pointer-events-none"></div>
      <div className="absolute bottom-0 right-1/4 w-72 h-72 bg-[#2d5a8c]/40 rounded-full blur-[80px] pointer-events-none"></div>

      {/* Top divider */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D97642] to-transparent opacity-60"></div>
      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D97642] to-transparent opacity-60"></div>

      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-8">
        {/* Eyebrow */}
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-[#D97642]/20 text-[#D97642] text-[11px] font-bold uppercase tracking-[0.2em] rounded-full border border-[#D97642]/30">
            Hoosier Life Insurance — By the Numbers
          </span>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-6">
          {stats.map((stat, i) => (
            <StatItem key={i} stat={stat} />
          ))}
        </div>

        {/* Bottom tagline */}
        <div className="mt-12 md:mt-16 text-center">
          <p className="text-[14px] md:text-[16px] text-white/60 italic">
            "Indianapolis families deserve every carrier's best rate — not just one company's only option."
          </p>
        </div>
      </div>
    </section>
  );
}